<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="旧ICCID：">
                <el-input v-model.trim="searchForm.id" @keyup.enter.native="getListHandler($event)" clearable></el-input>
            </el-form-item>
            <el-form-item label="转入卡ICCID：">
                <el-input v-model.trim="searchForm.pwd" @keyup.enter.native="getListHandler($event)" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getListHandler($event)" plain icon="el-icon-search">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
			border
			fit
			highlight-current-row
			style="width: 100%;"
			:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> 
            <el-table-column label="旧ICCID" width="180" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToUserBalance(scope.row)">{{ scope.row.old_iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column label="转入卡ICCID" width="180" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToUserBalance(scope.row)">{{ scope.row.new_iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column  align="center"  prop="price" label="转入金额（元）" width="120">
                <template slot-scope="scope">
                    <span >{{ scope.row.price/100 }}</span>
                </template>
            </el-table-column>

            <el-table-column  align="center" label="操作时间" prop="create_time" width="150"></el-table-column>
            <el-table-column  align="center" prop="remark" label="备注"></el-table-column>
            <el-table-column  align="center" prop="dispose_name" label="操作人" width="120"></el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

                 
    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {//字段不明问后端
                id: null,
                pwd: null,
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {

        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            let data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            common.sysRequest("sysUser/user/account/to/other/list", data, 'post').then(res=>{
                common.listCallback(this, res, 'tbpg');
            }) 

        },

        goToUserBalance(row){
            this.$store.commit('menu/setFromPage', 'balanceRechargeRecord');
            this.$store.commit('menu/setIccidToAccount', row.iccid);
            document.getElementById('userBalanceMenu').click();
        },
      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler();
        }  
    },
    created () {
        this.getListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

